<div class="login-page">
  <div class="box-white">
    <h1>Alterar senha</h1>
    <p class="intro-text">Sua senha expirou. Defina uma nova senha para continuar.</p>

    <div class="password-rules">
      <span class="rules-title">A senha deve:</span>
      <ul>
        <li *ngFor="let rule of passwordRules">{{ rule }}</li>
      </ul>
    </div>

    <form (ngSubmit)="submit()" [formGroup]="form" class="p-field">
      <div class="form-control" [ngClass]="{'invalid': isInvalid(form.get('newPassword'))}">
        <i class="icon pi pi-lock"></i>
        <span class="p-float-label">
          <input type="password" formControlName="newPassword" id="newPassword" name="newPassword"
                 pInputText autocomplete="new-password">
          <label for="newPassword">Nova senha *</label>
        </span>
      </div>

      <div class="form-control" [ngClass]="{'invalid': isInvalid(form.get('confirmPassword')) || form.hasError('mismatch')}">
        <i class="icon pi pi-lock"></i>
        <span class="p-float-label">
          <input type="password" formControlName="confirmPassword" id="confirmPassword" name="confirmPassword"
                 pInputText autocomplete="new-password">
          <label for="confirmPassword">Confirmar nova senha *</label>
        </span>
      </div>

      <div class="buttons">
        <button type="submit" [disabled]="form.invalid" class="easy-button full-width" pButton label="Alterar senha"></button>
      </div>
    </form>

    <div *ngIf="messageError" class="alert alert-danger text-center error-message">
      <strong>{{ messageError }}</strong>
    </div>
  </div>
</div>
